<template>
  <div>
    <generic-container
      :title="$t('robots')"
      icon="robot"
      :searchable="true"
      v-on:filter="filter"
      :header_buttons="header_buttons"
      :show_refresh="true"
      @refresh="getData"
      :show_plus="true"
      @add="add"
    >
      <!-- <h2 class="ui header">
        <i class="tools icon"></i>
        <div class="content">{{ $t("projects") }}</div>
      </h2> -->

      <div class="ui grid">
        <div class="four wide column">
          <div class="ui vertical fluid secondary pointing menu" ref="tabs">
            <a
              class="item"
              :data-tab="'branch_' + index"
              v-for="(project, index) in robots_by_project"
              :key="index"
            >
              {{ project.name }}
            </a>
          </div>
        </div>
        <div class="twelve wide stretched column">
          <div
            class="ui tab segment"
            style="margin-top:0"
            :data-tab="'branch_' + index"
            v-for="(item, index) in robots_by_project"
            :key="index"
          >
            <div class="ui selection list">
              <div
                class="item"
                v-for="(rbt, idx) in item.robots"
                :key="idx"
                @click="show_robot(rbt)"
              >
                <img class="mini ui image" src="/images/icons/robot.png" />
                <div class="content" style="width:90%">
                  <div class="ui right floated">
                    <div
                      class="right floated"
                      v-if="!rbt.setup.general.is_active"
                    >
                      <i class="red play icon"></i>
                      {{ $t("inactive") }}
                    </div>
                    <div
                      class="right floated"
                      v-if="rbt.setup.general.is_active"
                    >
                      <i class="green play icon"></i>
                      {{ $t("active") }}
                    </div>
                    <br />
                    <div class="right floated">
                      <i class="clock icon"></i>
                      <span>{{ cron_to_text(rbt.setup.general.cron) }}</span>
                    </div>
                    <br />
                    <div class="right floated" v-if="rbt.exists_file == false">
                      <i class="red exclamation icon"></i>
                      {{ $t("script not found") }}
                    </div>
                  </div>
                  <a class="header">{{ rbt.setup.general.name }}</a>
                  <div class="description">
                    {{ rbt.setup.general.description }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="ui two cards">
        <div
          class="card"
          v-for="(item, index) in robots_by_project"
          v-bind:key="index"
        >
          <div class="content">
            <img
              class="right floated mini ui image"
              src="/images/icons/industrial_robot.png"
            />
            <div class="header">{{ item.name }}</div>
            <div class="meta">
              <span>{{ robots_number(item.robots) }}</span>
            </div>
            <div class="ui selection list">
              <div
                class="item"
                v-for="(rbt, idx) in item.robots"
                :key="idx"
                @click="show_robot(rbt)"
              >
                <img class="mini ui image" src="/images/icons/robot.png" />
                <div class="content" style="width:90%">
                  <div class="ui right floated">
                    <div
                      class="right floated"
                      v-if="!rbt.setup.general.is_active"
                    >
                      <i class="red play icon"></i>
                      {{ $t("inactive") }}
                    </div>
                    <div
                      class="right floated"
                      v-if="rbt.setup.general.is_active"
                    >
                      <i class="green play icon"></i>
                      {{ $t("active") }}
                    </div>
                    <br />
                    <div class="right floated">
                      <i class="clock icon"></i>
                      <span>{{ cron_to_text(rbt.setup.general.cron) }}</span>
                    </div>
                    <br />
                    <div class="right floated" v-if="rbt.exists_file == false">
                      <i class="red exclamation icon"></i>
                      {{ $t("script not found") }}
                    </div>
                  </div>
                  <a class="header">{{ rbt.setup.general.name }}</a>
                  <div class="description">
                    {{ rbt.setup.general.description }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </generic-container>
    <template v-for="(mdl, index) in robot_modals">
      <component
        :is="mdl"
        :key="index"
        :robot_in="selected_robot"
        :projects="projects"
        @destroy="destroy"
        @succedded="succedded"
        @deleted="deleted"
      ></component>
    </template>
    <template v-for="(mdl, index) in ecosystem_modals">
      <component
        :is="mdl"
        :key="index"
        :robots="robots"
        @destroy="destroy_ecosystem"
      ></component>
    </template>
  </div>
</template>

<script>
import { local_api } from "@/utils";
import { cloneDeep } from "lodash";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import RobotModal from "./robot_modal/RobotModal";
import EcosystemModal from "./ecosystem_modal/EcosystemModal";
import { groupBy } from "lodash";
import cronstrue from "cronstrue/i18n";

// @ is an alias to /src
export default {
  name: "RobotIndex",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      robots: [],
      all_robots: [],
      robot_modals: [],
      ecosystem_modals: [],
      selected_robot: undefined,
      header_buttons: [
        {
          icon: "code",
          click: this.show_ecosystem,
          tooltip: this.$t("show ecosystem"),
        },
      ],
    };
  },
  computed: {
    robots_by_project() {
      let grps = groupBy(this.robots, function(rbt) {
        return rbt.setup.general.project;
      });

      let grouped = Object.keys(grps)
        .map((k) => {
          return {
            name: k,
            robots: grps[k],
          };
        })
        .sort((a, b) => {
          if (a.name > b.name) return 1;
          else if (a.name < b.name) return -1;
          else return 0;
        });

      return grouped;
    },
    projects() {
      let allProjects = this.robots.map((r) => {
        return r.setup.general.project;
      });
      return [...new Set(allProjects)];
    },
  },
  methods: {
    add() {
      this.robot_modals.push(RobotModal);
    },
    succedded(p) {
      let idx = this.robots.findIndex((r) => r.uuid == p.uuid);
      if (idx >= 0) this.robots.splice(idx, 1, p);
      else this.robots.push(p);
      this.destroy();
    },
    deleted(p) {
      let idx = this.robots.findIndex((r) => r.uuid == p.uuid);
      if (idx >= 0) this.robots.splice(idx, 1);
      this.destroy();
    },
    destroy() {
      setTimeout(() => {
        this.robot_modals = [];
        this.selected_robot = undefined;
      }, 300);
    },
    destroy_ecosystem() {
      setTimeout(() => {
        this.ecosystem_modals = [];
      }, 300);
    },
    filter(filter) {
      if (filter == "") this.robots = cloneDeep(this.all_robots);
      else
        this.robots = this.all_robots.filter(
          (n) =>
            n.setup.general.name.toUpperCase().includes(filter.toUpperCase()) ||
            n.setup.general.project
              .toUpperCase()
              .includes(filter.toUpperCase()) ||
            n.setup.general.description
              .toUpperCase()
              .includes(filter.toUpperCase()),
        );
    },
    robots_number(robots) {
      let lngth = robots.length;
      if (lngth == 1) return `${lngth} ${this.$i18n.t("robot")}`;
      else if (lngth > 1) return `${lngth} ${this.$i18n.t("robots")}`;
      else return "¿?";
    },
    show_robot(robot) {
      this.selected_robot = robot;
      this.robot_modals.push(RobotModal);
    },
    show_ecosystem() {
      this.ecosystem_modals.push(EcosystemModal);
    },
    getData() {
      let vm = this;
      local_api(vm, "post", "/robot/do-get-list")
        .then((rbts) => {
          this.robots = rbts;
          this.all_robots = cloneDeep(rbts);

          setTimeout(() => {
            window
              .jQuery(vm.$refs.tabs)
              .find(".item")
              .tab();
          }, 100);
        })
        .catch((err) => {
          vm.$alertify.error(JSON.stringify(err, null, 2));
        });
    },
    cron_to_text(cron) {
      if (cron) return cronstrue.toString(cron, { locale: this.$i18n.locale });
      else return "¿?";
    },
  },
  mounted() {
    this.getData();
  },
  watch: {},
};
</script>
